export default __webpack_public_path__ + "static/media/search.2c8d5f07.svg";